/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

/**
 *
 * @name app.module.HeaderDirective
 * @copyright 2015 Empower Retirement
 * @require angular
 * @description Directive responsible for the Site Header
 *
 */
import headerTemplate from "./headerTemplate";

let translateService = null;
let httpProvider = null;
let accuCodeService = null;

const HeaderDirective = function (transService, $http, AccuCodeService) {
    translateService = transService;
    httpProvider = $http;
    accuCodeService = AccuCodeService;

    const directive = {
        restrict: "E",
        controller: "HeaderController",
        scope: true,
        template: headerTemplate,
        link: initializeHeader
    };

    return directive;
};

HeaderDirective.$inject = ["translateService", "$http", "AccuCodeService"];

export default HeaderDirective;
